import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Button.scss';

const Button = ({
  type = 'button',
  onClick = () => {},
  className = '',
  disabled = false,
  fontSize = 16,
  text,
}) => (
  <div className={`btn ${className}`}>
    <button className={classnames(`size-${fontSize}`)} type={type} disabled={disabled} onClick={onClick}>{text}</button>
  </div>
);

Button.propTypes = {
  type: PropTypes.oneOf(['button', 'reset', 'submit']), // TO-DO: extend this array
  disabled: PropTypes.bool,
  fontSize: PropTypes.number,
  text: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Button;
